export const apiBaseUrl = process.env.REACT_APP_ORDER_API_URL
// export const crmApiBaseUrl = process.env.CRM_API_URL
export const crmApiBaseUrl = "https://www.binary-crm.itexpertplace.com/api"
export const apiBaseUrl1 = "https://www.binary-crm.itexpertplace.com/api"
export const apiKey = process.env.REACT_APP_ORDER_API_KEY
export const token = localStorage.getItem('token');
export const logoLight = "https://www.binary-crm.itexpertplace.com//assets/images/logoIcon/logo.png"
export const logoDark = "https://www.binary-crm.itexpertplace.com//assets/images/logoIcon/logo.png"

export const logoSm = "https://www.binary-crm.itexpertplace.com//assets/images/logoIcon/favicon.png"

const user = JSON.parse(localStorage.getItem('user'));
export const account = user ? user.account : null;